import { render, staticRenderFns } from "./supplementing-materials.vue?vue&type=template&id=5ea6388e&scoped=true"
import script from "./supplementing-materials.vue?vue&type=script&lang=js"
export * from "./supplementing-materials.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ea6388e",
  null
  
)

export default component.exports